import { CourseItem, CourseSection, COURSE_TYPE, CompletedStep, type CourseReportItem, type CourseReportSection } from '@/entities/trainings';

export const isSection = (item: CourseItem | CompletedStep): item is CourseSection => {
  return item.type === COURSE_TYPE.SECTION;
};

/**
 * Course / Report can have only sections or only non-section items on the top level
 *
 * @param items
 */
export function hasSections(items: Array<CourseItem>): items is Array<CourseSection>;
export function hasSections(items: Array<CourseReportItem>): items is Array<CourseReportSection>;
export function hasSections(items: Array<CourseItem | CourseReportItem>): items is Array<CourseSection | CourseReportSection> {
  return items.length > 0 && items[0].type === COURSE_TYPE.SECTION;
}
